import { useMutation } from "@tanstack/react-query";

import { handleCreateGameShareLink } from "../../api-clients/gamesShareClient";

function useCreateGameShareLinkMutation() {
  const mutation = useMutation({
    mutationFn: (gameId: string) => handleCreateGameShareLink(gameId),
  });

  return mutation;
}
export default useCreateGameShareLinkMutation;
